(() => {
    class Maps {
        constructor(sector) {
            if (!(sector instanceof HTMLElement)) return;
            
            const map = sector.querySelector('.maps__map');
            const markersEl = sector.querySelectorAll('.maps__marker');

            const generatedMap = new google.maps.Map(map, {
                zoom: 14,
                minZoom: 8,
                maxZoom: 18,
                zoomControl: true,
                scrollwheel: false,
                navigationControl: true,
                draggable: true,
                mapTypeId: google.maps.MapTypeId.ROADMAP,
            });

            generatedMap.markers = [];

            markersEl.forEach((el) => {
                const label = el.dataset.label;
                addMarker(el, generatedMap, label);
            });

            centerMap(generatedMap);
        }
    }

    class Handler {
        constructor(sector, sectorClass) {
            this.sector = sector;
            this.sectorClass = sectorClass;
            new Maps(this.sector);
        }
    }

    function addMarker(markerIcon, map) {
        const icon = {
            url: '/wp-content/themes/harwell/resources/svg/map.svg',
            anchor: new google.maps.Point(25, 25),
            scaledSize: new google.maps.Size(28, 35),
            origin: new google.maps.Point(0, 0),
        };
    
        const lat = parseFloat(markerIcon.dataset.lat);
        const lng = parseFloat(markerIcon.dataset.long);
        const coordinates = { lat, lng };
    
        const label = markerIcon.querySelector(".maps__marker-label");
        const marker = new google.maps.Marker({
            position: coordinates,
            map,
            icon,
        });

        const infowindow = new google.maps.InfoWindow({
            content: label.innerHTML,
        });

        // Remove the click listener
        // marker.addListener("click", function () {
        //     infowindow.open(map, marker);
        // });

        infowindow.open(map, marker); // Open the label immediately without click

        map.markers.push(marker);
    }

    function centerMap(map) {
        const bounds = new google.maps.LatLngBounds();
        map.markers.forEach((marker) => {
            bounds.extend(marker.getPosition());
        });

        map.fitBounds(bounds);
    }

    const sectorClass = 'maps';
    const sectors = Array.from(document.querySelectorAll(`section.${sectorClass}`));

    setTimeout(() => {
        sectors.forEach((o) => new Handler(o, sectorClass));
    }, 100);
})();
